import { Box } from '@mui/material';
import { TabList } from 'design-library';

import { ExpertsTable } from './ExpertsTable';
import { HirersTable } from './HirerTables';

export const UserManagement = () => (
  <Box px={4}>
    <TabList
      defaultTab="Experts"
      queryParam="activeSubTab"
      tabs={[
        {
          component: <ExpertsTable />,
          label: 'Experts',
        },
        {
          component: <HirersTable />,
          label: 'Hirers',
        },
      ]}
    />
  </Box>
);
